import React, { useState } from 'react';
import SelectSearchComp from 'react-select/async';
import debounce from 'lodash.debounce';
import './DropdownInput.scss';
import { getAddressAutoComplete } from '../../utils/googleMaps';
import { IDropdownInput } from './DropdownInput.types';

const getValue = (options: { value: string }[], checkValue: string) => {
  if (!options || !checkValue) {
    return null;
  }
  if (options.length === 0) return { value: checkValue, label: checkValue };
  const obj = options.filter((option) => option.value === checkValue);
  return obj;
};
const loadOptions = debounce(getAddressAutoComplete, 200);
const LocationDropdownInput = ({
  placeholder,
  label,
  value,
  onChange,
  name,
  error,
  required,
  disabled,
  countryCode,
}: IDropdownInput) => {
  const [options, setOptions] = useState([]);
  const promiseOptions = async (inputValue: any) => {
    if (loadOptions && inputValue?.trim()) {
      const response = await loadOptions(inputValue, countryCode || '');
      setOptions(response);
      return response;
    }
    return [];
  };

  const handleChange = (e: any) => {
    onChange({ target: { value: e.value, name, id: e?.id } });
  };
  const valueResult = getValue(options, value);

  return (
    <div className="wrapper">
      {label && value && <div className="wrapper__label">{label}</div>}
      <SelectSearchComp
        cacheOptions
        defaultOptions
        placeholder={placeholder}
        onChange={handleChange}
        className="basic-single"
        id="select-search-comp"
        styles={{
          control: (base: any) => ({
            ...base,
            border: '1px solid #e5e5e7',
            // This line disable the blue border
            boxShadow: 'none',
            height: '52px',
            color: 'black',
            paddingTop: value ? '16px' : '0px',
            background: disabled ? 'rgba(245,245,245, 0.7)' : 'rgba(255, 255, 255, 0.1)',
            paddingLeft: '5px',
            fontSize: '12px',
            // This line disable the outline border
            '&:hover': {
              boxShadow: 'none',
            },
            '&:focus': {
              boxShadow: 'none',
            },
          }),
          indicatorSeparator: (base: any) => ({
            ...base,
            display: 'none',
          }),
          singleValue: (base: any) => ({
            ...base,
            color: '#000000',
            fontSize: '12px',
            fontWeight: '400',
          }),
          option: (base: any, state: any) => ({
            ...base,
            color: state?.isSelected ? '#5941A9' : '#000000',
            backgroundColor: state?.isSelected ? 'rgba(89, 65, 169, 0.10)' : '#fff',
            fontSize: '13px',
            lineHeight: '24px',
            fontWeight: '400',

            zIndex: 5000,
            '&:hover': {
              backgroundColor: state?.isSelected ? 'rgba(89, 65, 169, 0.10)' : '#F5F5F5',
              cursor: 'pointer',
            },
          }),
          menu: (base: any) => ({
            ...base,
            zIndex: 7000,
          }),
          placeholder: (base: any) => ({
            ...base,
            fontSize: '12px',
            lineHeight: '24px',
            fontWeight: '400',
            color: 'black',
          }),
          dropdownIndicator: (base: any) => ({
            ...base,
            opacity: disabled ? '0' : '1',
          }),
        }}
        value={valueResult}
        required={required}
        isDisabled={disabled}
        loadOptions={promiseOptions}
      />
      {error && <div className="wrapper__error">{error}</div>}
    </div>
  );
};

export default LocationDropdownInput;
